import { render, staticRenderFns } from "./customise-modal.vue?vue&type=template&id=67742345&scoped=true"
import script from "./customise-modal.vue?vue&type=script&lang=js"
export * from "./customise-modal.vue?vue&type=script&lang=js"
import style0 from "./customise-modal.vue?vue&type=style&index=0&id=67742345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67742345",
  null
  
)

export default component.exports